import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';

import { updateReport } from '../api/reports.api';
import { REPORT_DETAIL_QUERY_KEY, REPORTS_QUERY_KEY } from '../constants/reports-query-keys';

export const useUpdateReport = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: ({ id, name }: { id: string; name: string }) => updateReport(id, name),
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: REPORTS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: REPORT_DETAIL_QUERY_KEY(data.id) });
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(error, 'authenticated.reports:toasts.updateError');
    },
  });
};
